<app-action-form [item]="item" [slot]="slot" [form]="form">
	<div class="form-section app-margin-horizontal app-padding">
        <div class="form-group" [formGroup]="form">
            <app-unit-quantity label="Rate" unitLabel="ml/kg/hr" placeholder="Value" inputMode="decimal" formControlName="rate"></app-unit-quantity>
            <app-unit-quantity label="Total Rate" unitLabel="ml/hr" placeholder="Value" inputMode="decimal" formControlName="totalRate"></app-unit-quantity>
        </div>
        <app-common-action-controls [action]="action" [form]="form"></app-common-action-controls>
      </div>
</app-action-form>